import { FormattedMessage } from "react-intl";

import { SelectInput } from "@dzambalaorg/mui-inputs-core";
import { TemplateAssetInput } from "@dzambalaorg/mui-inputs-asset";
import { ContractStatus, DismantleStatus, ModuleType, TokenType } from "@framework/types";
import { DialogMode } from "@framework/shared";
import { Alert, FormGrid } from "@dzambalaorg/ui-kit";

import { RarityMultiplierInput } from "./rarity-multiplier-input";
import { StrategyInput } from "./strategy-input";

export interface IDismantleDialogFormProps {
  mode: DialogMode;
}

export const DismantleDialogForm = (props: IDismantleDialogFormProps) => {
  const { mode } = props;

  return (
    <FormGrid columns={mode === "create" ? [2, 1, 1, 1, 1] : [2, 1, 1, 1, 1, 1]}>
      <StrategyInput name="dismantleStrategy" />
      <RarityMultiplierInput name="rarityMultiplier" />
      <Alert severity="info" sx={{ mt: 2 }}>
        <FormattedMessage id="alert.dismantlePrice" />
      </Alert>
      <TemplateAssetInput
        required
        autoSelect
        prefix="price"
        contract={{
          data: {
            contractModule: [ModuleType.HIERARCHY],
            contractStatus: [ContractStatus.ACTIVE, ContractStatus.NEW],
          },
        }}
        tokenType={{ disabledOptions: [TokenType.NATIVE, TokenType.ERC20] }}
      />
      <Alert severity="info" sx={{ mt: 2 }}>
        <FormattedMessage id="alert.dismantleItem" />
      </Alert>
      <TemplateAssetInput
        required
        autoSelect
        prefix="item"
        contract={{
          data: {
            contractModule: [ModuleType.HIERARCHY],
            contractStatus: [ContractStatus.ACTIVE, ContractStatus.NEW],
          },
        }}
        tokenType={{ disabledOptions: [TokenType.NATIVE] }}
        multiple
      />
      {mode === "edit" && <SelectInput name="dismantleStatus" options={DismantleStatus} />}
    </FormGrid>
  );
};
